// Copyright (c) 2022 by Move Closer

import { AsyncComponent } from 'vue'

/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
export enum SelenaFormModuleVersion {
  // Wystaw certyfikat
  IssueCertificate = 'issueCertificate',
  // Zaproś na budowę
  InviteToSite = 'inviteToSite',
  // Zapisz się na webinar
  Webinar = 'webinar',
  // Nowe terminy szkoleń
  NewTrainingDates = 'newTrainingDates',
  // Dopisz użytkownika do firmy
  ConnectUser = 'connectUser',
  // Przekształć konto użytkownika w konto firmowe
  ConvertUserToB2B = 'convertUserToB2B'
}

/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
export const selenaFormModuleVersionsRegistry: Record<string, AsyncComponent> = {
  [SelenaFormModuleVersion.Webinar]: () => import(
    /* webpackChunkName: "modules/SelenaFormWebinar" */
    './versions/Webinar.vue'
  ),
  [SelenaFormModuleVersion.NewTrainingDates]: () => import(
    /* webpackChunkName: "modules/SelenaFormNewTrainingDates" */
    './versions/NewTrainingDates.vue'
  ),
  [SelenaFormModuleVersion.IssueCertificate]: () => import(
    /* webpackChunkName: "modules/SelenaFormIssueCertificate" */
    './versions/IssueCertificate.vue'
  ),
  [SelenaFormModuleVersion.InviteToSite]: () => import(
    /* webpackChunkName: "modules/SelenaFormInviteToSite" */
    './versions/InviteToSite.vue'
  ),
}
